import {lazy, Suspense} from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import RouterFallback from "@/modules/Shared/components/RouterFallback/RouterFallback";
import {PARAMS_ANIMAL} from "@/App/Animals/routes/enums";
import {MAP_PROPS_ANIMAL_CONFIG} from "@/config/globalAnimalFrontEndConfig";
import {PATH_BUSCADOR_ANIMALES__ROOT} from "@/App/Animals/routes/resolvedRoutes";

const Component = lazy(async () => await import('./AnimalListPage'));
export default function AnimalList(props) {
    const location = useLocation();
    const navigate = useNavigate()
    const params = fixParamsReturn(useParams(), location)
    return (
        <Suspense fallback={<RouterFallback/>}>
            <Component {...props} params={params} location={location} navigate={navigate}/>
        </Suspense>
    );
}


function fixParams(params, location) {
    const pathAux = location.pathname.replace(PATH_BUSCADOR_ANIMALES__ROOT, "")
    params.especie = Object.keys(MAP_PROPS_ANIMAL_CONFIG.especie).find((especie) => pathAux.startsWith("/" + especie + PARAMS_ANIMAL.especie.suffix))

    if (params.raza && !params.raza.startsWith(PARAMS_ANIMAL.raza.prefix)){
        // params.pagina = params.tamano
        params.tamano = params.edad
        params.edad = params.sexo
        params.sexo = params.raza
        params.raza = undefined
    }

    Object.keys(PARAMS_ANIMAL).forEach(key => {
        params[key] = params[key]?.replace(new RegExp(`^${PARAMS_ANIMAL[key].prefix}|${PARAMS_ANIMAL[key].suffix}$`, "gmi"), "")
    })
}

function fixParamsReturn(params, location) {
    const pathAux = location.pathname.replace(PATH_BUSCADOR_ANIMALES__ROOT, "")
    params.especie = Object.keys(MAP_PROPS_ANIMAL_CONFIG.especie).find((especie) => pathAux.startsWith("/" + especie + PARAMS_ANIMAL.especie.suffix))

    if (params.raza && params.raza.startsWith(PARAMS_ANIMAL.pagina.prefix)){
        params.pagina = params.raza
        params.raza = undefined
    } else if (params.raza && !params.raza.startsWith(PARAMS_ANIMAL.raza.prefix)){
        // params.pagina = params.tamano
        params.tamano = params.edad
        params.edad = params.sexo
        params.sexo = params.raza
        params.raza = undefined
    }

    Object.keys(PARAMS_ANIMAL).forEach(key => {
        params[key] = params[key]?.replace(new RegExp(`^${PARAMS_ANIMAL[key].prefix}|${PARAMS_ANIMAL[key].suffix}$`, "gmi"), "")
    })
    return params
}